import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import Tooltip from '@mui/material/Tooltip';
import CustomTableGrid from "components/uiComponents/CustomTableGrid";
import FormikControl from "components/wrapperComponents/FormikControl";
import { msgTypes } from "constants/msgTypes";
import { RouteType } from 'constants/RouteType';
import { Form, Formik } from "formik";
import { PaginatorModel } from "model/utilModels/PaginatorModel";
import { ResponseModel } from "model/utilModels/ResponseModel";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { GrievenceRedressalService } from 'services/menu/grievencereRedressalService/GrievenceRedressalService';

const GrievenceList = ({ setFlag, updateRecord }) => {

  const [grievenceList, setGrievenceList] =  useState<ResponseModel | null>(null); 
  const paginatorModel: PaginatorModel = new PaginatorModel();
  const [pagination, setPagination] = useState({
    pageSize: paginatorModel.pageSize,
    pageNumber: paginatorModel.pageNumber,
    filter: "",
    orderBy: "",
    desc: "",
  });

  const navigate = useNavigate();

  // Navigate to the Announcement Display
  const handleOnClick = (row) => {
    navigate(RouteType.HOME + RouteType.VIEW_GRIEVANCE_DETAILS, { state: { grievanceDetails: row } });
  };

  useEffect(() => {
    getGrievenceRedressalList();
  }, [
    pagination.pageNumber,
    pagination.pageSize,
    pagination.filter,
    pagination.orderBy,
    pagination.desc,
  ]);

   // Prepare request body to get news letter list
   const prepareRequest = () => {
    const requestBody = new PaginatorModel();
    requestBody.pageNumber = pagination.pageNumber;
    requestBody.pageSize = pagination.pageSize;
    requestBody.filter = pagination.filter;
    requestBody.orderBy = pagination.orderBy;
    requestBody.desc = pagination.desc;
    return requestBody;
  };


  const initialValues = {};
  const onSubmit = () => {
    getGrievenceRedressalList();
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "companyName",
        header: "Company Name",
        size: 150,
      },
      {
        accessorKey: "debtorCompany",
        header: "Debtor Company",
        size: 150,
      },
      {
        accessorKey: "debtorCompanyAddress",
        header: "Debtor Company Address",
        size: 150,
      },
      
      {
        header: 'Action',
        Cell: ({ renderedCellValue, row }) => (
          <div className='d-flex'>
          <a href='javascript:void(0)' onClick={()=>{handleOnClick(row.original)}} color='primary'>
          <Tooltip title="View Profile">
              <RemoveRedEyeIcon fontSize="small"/>
            </Tooltip>
          </a>
          </div>
        ),
        size: 10,
        grow: false,
      },

    ],
    []
  );

   //Get News Letter List
   const getGrievenceRedressalList = async () => {
    const requestBody = prepareRequest();
    const res = await GrievenceRedressalService.getGrievanceRedressal(requestBody);

    if (res.statusMsg === msgTypes.SUCCESS.msg) {
        setGrievenceList(res);
    }
  };



  return (
    <>
    <Formik initialValues={initialValues} onSubmit={onSubmit}>
        {(formik) => (
          <Form>
               {grievenceList ? (
            <CustomTableGrid
              item={
                <FormikControl
                  control="materialTable"
                  tableColumn={columns}
                  tableData={grievenceList}
                  setPagination={setPagination}
                  enableClickToCopy = {true}
                 
                />
              }
            />
          ) : null}
          </Form>
        )}
      </Formik>
    </>
  )
}

export default GrievenceList;